/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from xplatforms/schemas/document_scanner/TextPattern.yaml
import { ScanbotTextPatternImpl } from './impl';
/**
 * Entry point for all Text Pattern scanning features.
 */
export const ScanbotTextPattern = {
    /**
     * Opens the Ready-To-Use UI Text Pattern scanner with the desired configuration.
     * @param {TextPatternScannerScreenConfiguration} configuration - The Text Pattern scanner configuration to be used for scanning.
     * @returns {Promise<ResultWrapper<TextPatternScannerUiResult>>} - The result of the Text Pattern scanning operation.
     */
    async startScanner(configuration) {
        return ScanbotTextPatternImpl.startScanner(configuration);
    },
};
//# sourceMappingURL=TextPattern.js.map